// src/locales/en/expenses.js
export const expenses = {
  // Page titles
  manageExpenses: 'Manage Expenses',
  viewAndManageExpenses: 'Record and track your business expenses',

  // Statistics
  totalExpenses: 'Total Expenses',
  totalAmount: 'Total Amount',
  filteredTotal: 'Filtered Total',

  // Actions
  recordNewExpense: 'Record Expense',
  editExpense: 'Edit Expense',
  deleteExpense: 'Delete Expense',
  createExpense: 'Save Expense',
  updateExpense: 'Update Expense',

  // Fields
  expenseDate: 'Expense Date',
  category: 'Category',
  subCategory: 'Sub-Category',
  selectCategory: 'Select category',
  selectSubCategory: 'Select sub-category (optional)',
  title: 'Title / Description',
  amount: 'Amount',
  paymentMethod: 'Payment Method',
  notes: 'Notes',
  createdBy: 'Recorded By',

  // Placeholders
  enterTitle: 'Enter expense title or description',
  enterAmount: 'Enter amount',
  enterNotes: 'Additional notes about this expense...',

  // Payment methods
  paymentMethods: {
    cash: 'Cash',
    bank_transfer: 'Bank Transfer',
    credit_card: 'Credit Card',
    cheque: 'Cheque',
    mobile_payment: 'Mobile Payment',
    other: 'Other',
  },

  // Search and filters
  searchExpenses: 'Search by title...',
  allCategories: 'All Categories',
  allPaymentMethods: 'All Payment Methods',
  dateFrom: 'Date From',
  dateTo: 'Date To',

  // Summary
  showingTotal: 'Total for filtered results',

  // Messages
  expenseCreatedSuccessfully: 'Expense recorded successfully',
  expenseUpdatedSuccessfully: 'Expense updated successfully',
  expenseDeletedSuccessfully: 'Expense deleted successfully',
  failedToLoadExpenses: 'Failed to load expenses',
  failedToLoadCategories: 'Failed to load expense categories',
  failedToCreateExpense: 'Failed to record expense',
  failedToUpdateExpense: 'Failed to update expense',
  failedToDeleteExpense: 'Failed to delete expense',

  // Empty states
  noExpensesYet: 'No Expenses Recorded',
  noExpensesYetDescription: 'Start tracking your business expenses by recording your first expense.',
  noExpensesFound: 'No Expenses Found',
  noExpensesFoundDescription: 'No expenses match your current filters. Try adjusting your search criteria.',

  // Delete confirmation
  confirmDelete: 'Are you sure you want to delete this expense?',
  confirmDeleteDescription: 'This action cannot be undone.',

  // Validation
  validation: {
    categoryRequired: 'Expense category is required',
    titleRequired: 'Title is required',
    titleMinLength: 'Title must be at least 2 characters',
    amountRequired: 'Amount is required',
    amountPositive: 'Amount must be a positive number',
    dateRequired: 'Expense date is required',
    paymentMethodRequired: 'Payment method is required',
    fixErrors: 'Please fix the errors in the form',
  },
};
